<template>
  <div>

    <div v-if="loading == true" class="row border-class mb-3 pb-2 align-items-center mx-5 " v-for="option in 3" style="border-bottom: 1px solid #CCC;">
      <div class="col-7">
        <div class="col-12">
          <PuSkeleton :count="1"></PuSkeleton>
        </div>
        <div class="col-10">
          <PuSkeleton :count="1"></PuSkeleton>
        </div>
      </div>
      <div class="col-2">
      </div>
      <div class="col-3">
        <div class="col-12">
          <PuSkeleton :count="1"></PuSkeleton>
        </div>
      </div>

    </div>



    <div class="mentee-progress-list">
    <div class="border-class mb-3 align-items-center mx-3 pr-3 pb-2" v-for="(objective, index) in progress" v-if="objective.objectiveType != 'Other Tasks'">
    <div class="row">
      <div v-if="objective.objectiveType == 'External Course'" class="col-1" style="margin-top: 0px;">
        <div class="text-uppercase h3 mb-0 text-success">
          <img :src="objective.image" width="35px" />
        </div>
      </div>
      <div v-else-if="objective.CompletionPercentage == 100" class="col-1">
        <div class="text-uppercase h3 mb-0 text-success">
          <img src="@/assets/manager/objective_completed.png" />
        </div>
      </div>
      <div v-else-if="objective.CompletionPercentage == 0" class="col-1">
        <div class="text-uppercase h3 mb-0 text-success">
          <img src="@/assets/manager/objective_not_completed.png" />
        </div>
      </div>
      <div v-else class="col-1">
        <div class="progress-circle" :style="'--percent: ' + objective.CompletionPercentage + '%;'">
          <i class="fa fa-check"></i>
        </div>
      </div>

      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Assessment' || objective.objectiveType == 'Course' || objective.objectiveType == 'Form')">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p v-if="objective.CompletionPercentage == 100" class="small text-muted mb-0">{{ objective.objectiveType }} Completed {{ objective.CompletionDate }}</p>
        <p v-if="objective.CompletionPercentage != 100 && objective.objectiveType == 'Course'" class="small text-muted mb-0">Course - {{ objective.courseCompleteCount }}/{{ objective.totalCourseCount }} Modules Completed</p>
        <p v-if="objective.CompletionPercentage != 100 && objective.objectiveType == 'Assessment'" class="small text-muted mb-0">Assessment</p>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Task List')">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0">Skill Set - {{ objective.CompletionPercentage }}% Complete</p>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'Certificate')">
        <p class="mb-0">Certifications - {{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0">Certifications - {{ objective.completedCertificateCount }}/{{ objective.totalCertificateCount }}</p>
      </div>
      <div class="col-7 col-xl-7" v-if="(objective.objectiveType == 'External Course')">
        <p class="mb-0">{{ objective.objectiveName }}</p>
        <p class="small text-muted mb-0">External Course {{ objective.expires }}</p>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="(objective.buttonName == 'Incomplete')" style="padding-left: 5px;">
        <a class="progress_item_link font-weight-bold" style="color: #333 !important;">{{ objective.buttonName }} </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Assessment' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="viewReport(objective.userAssessmentAttemptId)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Form' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="goToViewForm(objective.objectiveId)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'Course' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="viewCourseReport(objective.cert)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="objective.objectiveType == 'Task List'" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click.prevent="openTaskListModal(objective.objectiveId)">Skills 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
      <div class="col-4 col-xl-4 pr-0 text-right" v-if="objective.objectiveType == 'Certificate'" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold"  @click.prevent="openCertificationModal(objective.objectiveId)">Certifications 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>


      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'External Course') && (objective.CompletionPercentage != 100) && (objective.buttonName == 'Upload Certification')  && checkIsManager())" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="openCourseCertificationModal(objective.objectiveId, objective.id)">{{ objective.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>

      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'External Course') && (objective.CompletionPercentage != 100) && (objective.buttonName == 'Approve Certification')  && checkIsManager())" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="approveCertificationModalOpen(objective.objectiveId, objective.id)">{{ objective.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
      </div>

      <div class="col-4 col-xl-4 pr-0 text-right" v-if="((objective.objectiveType == 'External Course' && objective.CompletionPercentage == 100))" style="padding-left: 5px;">
        <a class="progress_item_link branding_text_color font-weight-bold" @click="downloadCourseFunc(objective.fileName)">{{ objective.buttonName }} 
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>


    </div>
    </div>
    </div>
    <div v-if="isTaskListModalVisible">
    <MenteeTasklists 
      :isModalVisible="isTaskListModalVisible"
      :type="type"
      @close="closeTaskListModal"
      @closeTaskListModal="closeTaskListModal"
      @closeAddRep="closeAddRep"
      ref="TaskListModal">
    </MenteeTasklists>
    </div>

    <div v-if="isCertificationModalVisible">
    <MenteeCertifications 
      :isModalVisible="isCertificationModalVisible"
      :type="type"
      @close="closeCertificationModal"
      @closeTaskListModal="closeCertificationModal"
      ref="CertificationModal">
    </MenteeCertifications>
    </div>

    <div v-if="isCourseCertificationModalVisible">
    <MenteeUploadCourseCertifications 
      :isModalVisible="isCourseCertificationModalVisible"
      :type="type"
      @close="closeCourseCertificationModal"
      @closeTaskListModal="closeCourseCertificationModal"
      ref="CourseCertificationModal">
    </MenteeUploadCourseCertifications>
    </div>

    <div v-if="isMenteeApproveComponentVisible">
    <MenteeApproveCertificate 
      :isModalVisible="isMenteeApproveComponentVisible"
      :type="type"
      @close="approveCertificationModalClose"
      @closeMenteeApproveModal="approveCertificationModalClose"
      ref="MenteeApproveModal">
    </MenteeApproveCertificate>
    </div>


  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import RightPanelModal from '@/components/manager/right_panel_modal.vue';
import MenteeTasklists from '@/components/manager/mentee_tasklists_new.vue';
import MenteeCertifications from '@/components/manager/mentee_certifications.vue';
import autocomplete from '@/components/admin/autocomplete.vue';
import MenteeAddRep from '@/components/manager/mentee_add_rep.vue';
import MenteeTasklistsOtherTask from '@/components/manager/mentee_tasklist_add_othertask_from_progress_modal.vue';
import { customSleep } from '@/components/shared/utils.js';
import MenteeUploadCourseCertifications from '@/components/manager/mentee_upload_course_certificate.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';
import MenteeApproveCertificate from '@/components/manager/mentee_approve_course_certificate.vue';

export default {
  props: ['menteeId', 'isModalVisible', 'stepId', 'pathwayId', 'type'],
  data() {
    return {
      progress: [],
      taskListId: '',
      nextStepId: '',
      nextStepTitle: '',
      currentStepId: '',
      stepIsCompleted: false,
      pathwayStartDate: '',
      isTaskListModalVisible: false,
      placeHolderInputText: 'Search tasks',
      autoCompleteTasksResult: [],
      autoCompleteTasksProgress: false,
      tasks: '',
      tasksId: '',
      subTaskId: '',
      isMenteeAddRepModalVisible: false,
      isOtherTaskModalVisible: false,
      isDeleteModalVisible: false,
      stepCompletedPercentage: 0,
      isCertificationModalVisible: false,
      isCourseCertificationModalVisible: false,
      isMenteeApproveComponentVisible: false,
    }
  },
  components: {
    RightPanelModal,
    MenteeTasklists,
    autocomplete,
    MenteeAddRep,
    MenteeTasklistsOtherTask,
    MenteeCertifications,
    MenteeUploadCourseCertifications,
    MenteeApproveCertificate,
  },
  methods: {
        checkIsMentor() {
            return checkIsMentor();
        },
        checkIsManager() {
            return checkIsManager();
        },
    closeAddRep() {
      this.$emit('closeAddRep');
    },
    downloadCourseFunc: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/course_certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    approveCertificationModalOpen(courseId, stepObjectiveId) {
      this.isMenteeApproveComponentVisible = true;
      setTimeout(() => { 
      this.$refs.MenteeApproveModal.getMenteeCertificatesData(this.menteeId, courseId, this.currentStepId, stepObjectiveId);
      }, 500);
    },
    approveCertificationModalClose() {
      this.reloadStep(this.currentStepId);
      this.isMenteeApproveComponentVisible = false;
    },
    openCourseCertificationModal(courseId, objectiveId) {
      this.isCourseCertificationModalVisible = true;
      setTimeout(() => { 
      this.$refs.CourseCertificationModal.getMenteeCertificatesData(this.menteeId, courseId, this.currentStepId, objectiveId);
      }, 500);
    },
    closeCourseCertificationModal() {
      this.reloadStep(this.currentStepId);
      this.isCourseCertificationModalVisible = false;
    },
    openCertificationModal(certId) {
      this.isCertificationModalVisible = true;
      setTimeout(() => { 
      this.$refs.CertificationModal.getMenteeCertificatesData(this.menteeId, certId, this.currentStepId);
      }, 500);
    },
    closeCertificationModal() {
      this.reloadStep(this.currentStepId);
      this.isCertificationModalVisible = false;
    },
    closeTaskListOtherTasksModal() {
      this.reloadStep(this.currentStepId);
      this.isOtherTaskModalVisible = false;
    },
    addOtherTaskModal() {
      this.$refs.TaskListOtherTaskModal.getTaskLists(this.menteeId);
      this.isOtherTaskModalVisible = true;
    },
    openMenteeAddRepModal() {
      if(this.type == 2) {
        var Ptype = '';
      }
      else {
        Ptype = 1;
      }
      this.$refs.MenteeAddRepModal.getRepData(this.taskListId, this.subTaskId, this.tasksId, this.menteeId, 'no', '', Ptype);
      this.isMenteeAddRepModalVisible = true;
    },  
    closeMenteeAddRepModal(subtaskIndex, type) {
      this.$refs.autocomplete1.setValue('');
      this.isMenteeAddRepModalVisible = false;
    },
    closeMenteeEditRepModal() {
      this.$refs.autocomplete1.setValue('');
      this.isMenteeAddRepModalVisible = false;
    },


    openTaskListModal(taskListId) {
      this.isTaskListModalVisible = true;
      setTimeout(() => { 
      this.$refs.TaskListModal.getMenteeTasklistsData(this.menteeId, taskListId);
      }, 500);
    },
    closeTaskListModal() {
      this.isTaskListModalVisible = false;
    },
    viewCourseReport: function(url) {
        window.open(url, '_blank');
    },
    goToViewForm(formId) {
      var formViewUrl = '/desktop/mentee-forms-manager/view-form/'+formId+'/' + this.$store.state.user_accountid+ '/' + this.menteeId;
      
      axios.get(formViewUrl, {
      })
      .then(response =>  {        
        window.open(process.env.API_ENDPOINT + '/web/forms/' +response.data.filepath, '_blank');                        
      })
      .catch(function(err) {
        console.log("Come here"+ err);
      });
    },
    viewReport: function(id) {
       let routeData = this.$router.resolve({name: 'assessmentreportnew', params: {assessmentAttemptId: id}});
        window.open(routeData.href, '_blank');
    },
    openTasklistModal(event, taskListId) {
      this.taskListId = taskListId;
      event.preventDefault();
      event.stopPropagation();
      this.$refs.rightPanelModal.show();
    },
    reloadStep(stepId) {
      this.getMenteeProgressData(stepId);  
    },
    getMenteeProgressData(stepId) {
      this.loading = true;
      this.currentStepId = stepId;
      this.progress = [];
      axios.get('/desktop/v2/get-mentee-progress/' + this.menteeId, {
        params: {
          account_id: this.$store.state.user_accountid,
          step_id: stepId,
          pathway_id: this.pathwayId,
        }
      })
      .then(response =>  {      
        this.loading = false;    
        this.progress = response.data.progress;   
      })
      .catch(function() { });
    },
  },
  created() {
    this.getMenteeProgressData(this.stepId);
  },
}
</script>


<style scoped>
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.progress-circle {
  position: relative;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: conic-gradient(#00acee var(--percent, 0%), lightgrey 0%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.progress-circle .fa-check {
  font-size: 0.8rem;
}
.progress-circle::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  border-radius: 50%;
  background: white;
  z-index: 1;
}
.progress-circle .fa-check {
  z-index: 2;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}
</style>
<style>
.search_tasks_txtbox .autocomplete {
  width: 100%;
}
.search_tasks_txtbox .autocomplete input {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 5px;
  height: 28px;
  padding-bottom: 0px;
  padding-top: 0px;
  border: 1px solid lightgray;
}
a {
  cursor: pointer;
}
.mentee-progress-list .border-class:not(:last-child) {
  border-bottom: 1px solid #CCC;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/dashboard_mentee_progress.vue